export enum ProfieciencyLevel {
	BASICS = 'Basics',
	FAMILIARITY = 'Familiarity',
	GOOD_KNOWLEDGE = 'Good Knowledge',
	VERY_GOOD = 'Very Good',
	EXCELLENT = 'Excellent'
}
